import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimeFromIsoPipe } from './parsing/date-time-from-iso.pipe';
import { DateTimeToFormatPipe } from './formatting/date-time-to-format.pipe';

// Pulled necessary pipes from @dstelljes/luxon-angular under MIT license
// https://github.com/dstelljes/luxon-angular

export {
  DateTimeFromIsoPipe
};

/** @internal */
const PIPES = [
  DateTimeFromIsoPipe,
  DateTimeToFormatPipe
];

@NgModule({
  declarations: PIPES,
  exports: [PIPES]
})
export class DateTimeModule { }
